/* @radix-ui/colors/black-alpha.css */
/* START */
:root {
  --black-a1: rgba(0, 0, 0, 0.05);
  --black-a2: rgba(0, 0, 0, 0.1);
  --black-a3: rgba(0, 0, 0, 0.15);
  --black-a4: rgba(0, 0, 0, 0.2);
  --black-a5: rgba(0, 0, 0, 0.3);
  --black-a6: rgba(0, 0, 0, 0.4);
  --black-a7: rgba(0, 0, 0, 0.5);
  --black-a8: rgba(0, 0, 0, 0.6);
  --black-a9: rgba(0, 0, 0, 0.7);
  --black-a10: rgba(0, 0, 0, 0.8);
  --black-a11: rgba(0, 0, 0, 0.9);
  --black-a12: rgba(0, 0, 0, 0.95);
}

@supports (color: color(display-p3 1 1 1)) {
  @media (color-gamut: p3) {
    :root {
      --black-a1: color(display-p3 0 0 0 / 0.05);
      --black-a2: color(display-p3 0 0 0 / 0.1);
      --black-a3: color(display-p3 0 0 0 / 0.15);
      --black-a4: color(display-p3 0 0 0 / 0.2);
      --black-a5: color(display-p3 0 0 0 / 0.3);
      --black-a6: color(display-p3 0 0 0 / 0.4);
      --black-a7: color(display-p3 0 0 0 / 0.5);
      --black-a8: color(display-p3 0 0 0 / 0.6);
      --black-a9: color(display-p3 0 0 0 / 0.7);
      --black-a10: color(display-p3 0 0 0 / 0.8);
      --black-a11: color(display-p3 0 0 0 / 0.9);
      --black-a12: color(display-p3 0 0 0 / 0.95);
    }
  }
}
/* @radix-ui/colors/black-alpha.css */
/* END */

/* Reset ALL Radix-generated trigger buttons so browser defaults
   don't create opaque backgrounds that hide icons */
button[data-state] {
	all: unset;
	display: inline-flex !important;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	box-sizing: border-box;
	color: inherit !important;
	-webkit-tap-highlight-color: transparent;
}

button[data-state]:hover,
button[data-state]:focus,
button[data-state]:focus-visible,
button[data-state]:active,
button[data-state][data-state="open"] {
	background: none !important;
	border: none !important;
	outline: none !important;
	color: inherit !important;
}

.DropdownMenuContent,
.DropdownMenuSubContent {
	min-width: 180px;
	border-radius: 16px;
	padding: 8px;
	box-shadow: 0px 10px 38px -10px rgba(0, 0, 0, 0.35), 0px 10px 20px -15px rgba(0, 0, 0, 0.2);
	animation-duration: 350ms;
	animation-timing-function: cubic-bezier(0.15, 1.15, 0.3, 1.35);
	will-change: transform, opacity;
	font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;
	background: #ffffff !important;
	border: 1px solid rgba(0, 0, 0, 0.12) !important;
	opacity: 1 !important;
	backdrop-filter: none !important;
	-webkit-backdrop-filter: none !important;
}

/* Model selector dropdown - allow internal scrolling */
.DropdownMenuContent.ModelSelectorDropdown {
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.DropdownMenuContent.ModelSelectorDropdown > div {
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	overflow: hidden;
}

.DropdownMenuContent.ThinkingPowerDropdown {
	width: 300px;
	padding: 10px 12px 12px;
	border-radius: 16px;
	pointer-events: auto;
}

/* Catalog category / facet filters — scroll long lists */
.DropdownMenuContent.ExploreCategoryDropdown,
.DropdownMenuContent.CatalogCategoryDropdown {
	padding: 4px !important;
}

#explore-category-menu-scroll,
#catalog-category-menu-scroll,
#catalog-facets-menu-scroll {
	overflow-y: auto !important;
	scrollbar-gutter: stable;
}

#explore-category-menu-scroll::-webkit-scrollbar,
#catalog-category-menu-scroll::-webkit-scrollbar,
#catalog-facets-menu-scroll::-webkit-scrollbar {
	width: 6px;
}

#explore-category-menu-scroll::-webkit-scrollbar-track,
#catalog-category-menu-scroll::-webkit-scrollbar-track,
#catalog-facets-menu-scroll::-webkit-scrollbar-track {
	background: transparent;
}

#explore-category-menu-scroll::-webkit-scrollbar-thumb,
#catalog-category-menu-scroll::-webkit-scrollbar-thumb,
#catalog-facets-menu-scroll::-webkit-scrollbar-thumb {
	background: rgba(128, 128, 128, 0.45);
	border-radius: 3px;
}

#explore-category-menu-scroll::-webkit-scrollbar-thumb:hover,
#catalog-category-menu-scroll::-webkit-scrollbar-thumb:hover,
#catalog-facets-menu-scroll::-webkit-scrollbar-thumb:hover {
	background: rgba(128, 128, 128, 0.7);
}

[theme="black"] #explore-category-menu-scroll::-webkit-scrollbar-thumb,
[theme="black"] #catalog-category-menu-scroll::-webkit-scrollbar-thumb,
[theme="black"] #catalog-facets-menu-scroll::-webkit-scrollbar-thumb,
[theme="dark"] #explore-category-menu-scroll::-webkit-scrollbar-thumb,
[theme="dark"] #catalog-category-menu-scroll::-webkit-scrollbar-thumb,
[theme="dark"] #catalog-facets-menu-scroll::-webkit-scrollbar-thumb {
	background: rgba(255, 255, 255, 0.25);
}

[theme="black"] #explore-category-menu-scroll::-webkit-scrollbar-thumb:hover,
[theme="black"] #catalog-category-menu-scroll::-webkit-scrollbar-thumb:hover,
[theme="black"] #catalog-facets-menu-scroll::-webkit-scrollbar-thumb:hover,
[theme="dark"] #explore-category-menu-scroll::-webkit-scrollbar-thumb:hover,
[theme="dark"] #catalog-category-menu-scroll::-webkit-scrollbar-thumb:hover,
[theme="dark"] #catalog-facets-menu-scroll::-webkit-scrollbar-thumb:hover {
	background: rgba(255, 255, 255, 0.4);
}

/* Dark theme dropdown backgrounds */
[theme="black"] .DropdownMenuContent,
[theme="black"] .DropdownMenuSubContent,
[theme="dark"] .DropdownMenuContent,
[theme="dark"] .DropdownMenuSubContent {
	background: #1e1e1e !important;
	border: 1px solid rgba(255, 255, 255, 0.15) !important;
}

/* Add specific submenu styling for better hover behavior */
.DropdownMenuSubContent {
  /* Add a small margin to create a bridge between trigger and content */
  margin-left: -2px;
	max-width: 500px;
}

/* Ensure submenu trigger has proper hover area */
.DropdownMenuSubTrigger {
  position: relative;
}

.DropdownMenuSubTrigger::after {
  content: '';
  position: absolute;
  right: -4px;
  top: 0;
  bottom: 0;
  width: 8px;
  background: transparent;
}

/* make this the background translucent like apple and chatinputfloating background blur */

.DropdownMenuContent[data-side="top"],
.DropdownMenuSubContent[data-side="top"] {
	animation-name: slideDownAndFade;
	transform-origin: bottom;
}
.DropdownMenuContent[data-side="right"],
.DropdownMenuSubContent[data-side="right"] {
	animation-name: slideLeftAndFade;
	transform-origin: left;
}
.DropdownMenuContent[data-side="bottom"],
.DropdownMenuSubContent[data-side="bottom"] {
	animation-name: slideUpAndFade;
	transform-origin: top;
}
.DropdownMenuContent[data-side="left"],
.DropdownMenuSubContent[data-side="left"] {
	animation-name: slideRightAndFade;
	transform-origin: right;
}

.DropdownMenuItem,
.DropdownMenuSubTrigger,
.DropdownMenuCheckboxItem,
.DropdownMenuRadioItem {
	flex-direction: row;
  cursor: pointer;
	font-size: 14px;
	line-height: 1;
	border-radius: 8px;
	display: flex;
	align-items: center;
	height: 30px;
	padding: 0 5px;
	position: relative;
	user-select: none;
	outline: none;
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;
	color: #ffffff;
}

.DropdownMenuItem:hover,
.DropdownMenuSubTrigger:hover,
.DropdownMenuCheckboxItem:hover,
.DropdownMenuRadioItem:hover {
	background-color: rgba(255, 255, 255, 0.12);
}

/* Light theme item colors */
[theme="white"] .DropdownMenuItem,
[theme="white"] .DropdownMenuSubTrigger,
[theme="white"] .DropdownMenuCheckboxItem,
[theme="white"] .DropdownMenuRadioItem {
	color: #1a1a1a;
}

[theme="white"] .DropdownMenuItem:hover,
[theme="white"] .DropdownMenuSubTrigger:hover,
[theme="white"] .DropdownMenuCheckboxItem:hover,
[theme="white"] .DropdownMenuRadioItem:hover {
	background-color: rgba(0, 0, 0, 0.06);
}

/* Dark theme item colors */
[theme="black"] .DropdownMenuItem,
[theme="black"] .DropdownMenuSubTrigger,
[theme="black"] .DropdownMenuCheckboxItem,
[theme="black"] .DropdownMenuRadioItem,
[theme="dark"] .DropdownMenuItem,
[theme="dark"] .DropdownMenuSubTrigger,
[theme="dark"] .DropdownMenuCheckboxItem,
[theme="dark"] .DropdownMenuRadioItem {
	color: #ffffff;
}

[theme="black"] .DropdownMenuItem:hover,
[theme="black"] .DropdownMenuSubTrigger:hover,
[theme="black"] .DropdownMenuCheckboxItem:hover,
[theme="black"] .DropdownMenuRadioItem:hover,
[theme="dark"] .DropdownMenuItem:hover,
[theme="dark"] .DropdownMenuSubTrigger:hover,
[theme="dark"] .DropdownMenuCheckboxItem:hover,
[theme="dark"] .DropdownMenuRadioItem:hover {
	background-color: rgba(255, 255, 255, 0.12);
}

.DropdownMenuCheckboxItem,
.DropdownMenuRadioItem {
  padding-right: 25px;
}
.DropdownMenuItemIcon {
  height: 22px;
  width: 22px;
  display: flex;
  margin-right: 4px;
  align-items: center;
  justify-content: center;
}

.DropdownMenuItemIconActive {
	margin-left: auto;
}

.DropdownMenuItem[data-disabled],
.DropdownMenuCheckboxItem[data-disabled],
.DropdownMenuRadioItem[data-disabled],
.DropdownMenuSubTrigger[data-disabled] {
	pointer-events: none;
	opacity: 0.5;
}

.DropdownMenuLabel {
	padding-left: 5px;
	font-size: 12px;
	line-height: 30px;
	color: #888888;
}

[theme="white"] .DropdownMenuLabel {
	color: #666666;
}

[theme="black"] .DropdownMenuLabel,
[theme="dark"] .DropdownMenuLabel {
	color: #888888;
}

.DropdownMenuSeparator {
	height: 1px;
	margin: 5px 0;
	background-color: rgba(255, 255, 255, 0.15);
}

[theme="white"] .DropdownMenuSeparator {
	background-color: rgba(0, 0, 0, 0.12);
}

[theme="black"] .DropdownMenuSeparator,
[theme="dark"] .DropdownMenuSeparator {
	background-color: rgba(255, 255, 255, 0.15);
}

.DropdownMenuItemIndicator {
	position: absolute;
	right: 0;
	width: 25px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.DropdownMenuArrow {
	fill: white;
}

.IconButton {
	font-family: inherit;
	border-radius: 100%;
	height: 35px;
	width: 35px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.RightSlot {
	margin-left: auto;
	padding-left: 20px;
}

/* ----------------------------------------------------------------------
   Sidebar row hover-reveal action slot ("..." more-options trigger)

   The trigger on sidebar chat/collection rows is hidden by default and
   revealed when the row is hovered or focused. We drive this purely with
   CSS :hover / :focus-within rather than JS pointer-event state: the
   browser never drops a hover the way pointerenter/pointerleave listeners
   can during fast cursor movement or when the Radix menu trigger grabs
   pointer capture. That JS flakiness was what made the button flicker and
   disappear right as you tried to click it.

   Hide-until-hover is gated to fine pointers (mouse/trackpad). On touch
   (mobile Safari/Chrome) the first tap applies :hover / :focus-within and
   iOS suppresses the click whenever that hover reveals a previously-hidden
   control — so opening a chat from Your Chats required two taps. Touch
   keeps the slot visible so the first tap navigates.

   data-sidebar-actions="visible" (set for the active row and while the
   menu is open) forces the slot on regardless of hover.
---------------------------------------------------------------------- */
[data-sidebar-actions] {
	transition: opacity 0.12s ease;
}
[data-sidebar-actions="visible"] {
	opacity: 1;
}
@media (hover: hover) and (pointer: fine) {
	[data-sidebar-actions="hidden"] {
		opacity: 0;
		pointer-events: none;
	}
	[data-sidebar-row]:hover [data-sidebar-actions="hidden"],
	[data-sidebar-row]:focus-within [data-sidebar-actions="hidden"] {
		opacity: 1;
		pointer-events: auto;
	}
	/* Let Your Chats titles use the space vacated by metadata and the hidden
	   menu slot. Hover/focus restores their natural widths, so only the title's
	   truncation point changes. Touch keeps every detail in the normal layout. */
	[data-sidebar-row] [data-sidebar-chat-title] {
		max-width: 100%;
	}
	[data-sidebar-row]:not(:hover):not(:focus-within) [data-sidebar-chat-metadata],
	[data-sidebar-row]:not(:hover):not(:focus-within) [data-sidebar-chat-row] + [data-sidebar-actions="hidden"] {
		display: none;
	}
}

/* ----------------------------------------------------------------------
   Memory row hover-reveal edit/delete

   Same rationale as sidebar actions: JS onHoverIn/onHoverOut is dropped
   when the Radix tooltip portal mounts over the trigger, so the delete
   button vanished the moment its tooltip appeared. CSS :hover on the row
   stays true while the pointer is on the button.
---------------------------------------------------------------------- */
[data-memory-actions] {
	transition: opacity 0.2s ease;
}
[data-memory-actions="visible"] {
	opacity: 1;
}
@media (hover: hover) and (pointer: fine) {
	[data-memory-actions="hidden"] {
		opacity: 0;
	}
	[data-memory-item]:hover [data-memory-actions="hidden"],
	[data-memory-item]:focus-within [data-memory-actions="hidden"] {
		opacity: 1;
	}
}

@keyframes slideUpAndFade {
	from {
		opacity: 0;
		transform: translateY(2px) scale(0.905);
	}
	to {
		opacity: 1;
		transform: translateY(0) scale(1);
	}
}

@keyframes slideRightAndFade {
	from {
		opacity: 0;
		transform: translateX(-2px) scale(0.905);
	}
	to {
		opacity: 1;
		transform: translateX(0) scale(1);
	}
}

@keyframes slideDownAndFade {
	from {
		opacity: 0;
		transform: translateY(-2px) scale(0.905);
	}
	to {
		opacity: 1;
		transform: translateY(0) scale(1);
	}
}

@keyframes slideLeftAndFade {
	from {
		opacity: 0;
		transform: translateX(2px) scale(0.905);
	}
	to {
		opacity: 1;
		transform: translateX(0) scale(1);
	}
}

/* Desktop nav mega menus (use cases, etc.) */
.DropdownMenuContent.NavMegaMenuContent {
	min-width: min(720px, calc(100vw - 32px));
	max-width: 720px;
	padding: 10px 12px 12px;
	position: relative;
}

.DropdownMenuContent.NavMegaMenuContent .DropdownMenuItem {
	padding-right: 3px;
}

/* Invisible bridge across the trigger↔panel gap so the close timer does not
   start while the pointer crosses the portaled offset. Only rendered when the
   panel sits below its trigger; a flipped panel would put it on empty space. */
.DropdownMenuContent.NavMegaMenuContent[data-side="bottom"]::before {
	content: '';
	position: absolute;
	top: -12px;
	left: 0;
	right: 0;
	height: 12px;
}

/* Nav rows inside a dropdown. Layout lives here rather than in a style prop
   because `Link asChild` turns a sibling `className` into a `$$css` entry and
   would otherwise read these values as class names. */
[data-nav-link-row] {
	gap: 8px;
	width: 100%;
}

/* Radix focuses the trigger when a menu opens; kill the default blue ring.
   The public nav triggers render as <a> (not <button>) because of the
   crawlable `Link asChild` chain, so `button:focus` rules never reach them. */
[data-nav-mega-menu-trigger],
[data-public-nav-button],
[data-nav-mega-menu-trigger]:focus,
[data-public-nav-button]:focus,
[data-nav-mega-menu-trigger]:focus-visible,
[data-public-nav-button]:focus-visible,
[data-nav-mega-menu-trigger]:focus-within,
[data-public-nav-button]:focus-within,
[data-nav-mega-menu-trigger] *:focus,
[data-public-nav-button] *:focus,
[data-nav-mega-menu-trigger] *:focus-visible,
[data-public-nav-button] *:focus-visible,
button[data-state][aria-haspopup="menu"]:focus,
button[data-state][aria-haspopup="menu"]:focus-visible,
button[data-state][aria-haspopup="menu"] [tabindex="0"]:focus,
button[data-state][aria-haspopup="menu"] [tabindex="0"]:focus-visible {
	outline: none !important;
	box-shadow: none !important;
}

/* Public nav pills — glass hover, solid active (colors from Button variants). */
[data-public-nav-button] {
	transition: background-color 0.18s ease, backdrop-filter 0.18s ease, transform 0.18s ease !important;
}

@media (max-width: 768px) {
	.DropdownMenuContent,
	.DropdownMenuSubContent {
		min-width: 200px !important;
	}
	/* Force subcontent to stay within viewport on mobile */
	.DropdownMenuSubContent {
		max-width: calc(100vw - 32px) !important;
		margin-left: 0 !important;
	}
	.DropdownMenuLabel,
	.DropdownMenuCheckboxItem,
	.DropdownMenuRadioItem {
		padding-right: 30px !important;
	}
	.DropdownMenuItem,
	.DropdownMenuSubTrigger,
	.DropdownMenuCheckboxItem,
	.DropdownMenuRadioItem {
		height: 38px !important;
	}
	.DropdownMenuLabel {
		line-height: 30px !important;
	}
	.DropdownMenuItem,
	.DropdownMenuSubTrigger,
	.DropdownMenuCheckboxItem,
	.DropdownMenuRadioItem {
		font-size: 15px !important;
	}
	.DropdownMenuSeparator {
		margin: 5px 0 10px !important;
	}
	.DropdownMenuItemIndicator {
		right: 2px !important;
	}
	.DropdownMenuItemIndicator div,
	.DropdownMenuItemIndicator svg {
		width: 14px !important;
		height: 14px !important;
	}
}
/* Reactions are a compact emoji tray, rather than a full action menu. */
.DropdownMenuContent.MessageReactionPicker {
	min-width: 0 !important;
	width: max-content;
	display: grid;
	grid-template-columns: repeat(10, 40px);
	gap: 2px;
	padding: 6px;
	border-radius: 28px;
}

.MessageReactionOption {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	font-size: 25px;
	line-height: 1;
	cursor: pointer;
	user-select: none;
	outline: none;
	transition: background-color 120ms ease, transform 120ms ease;
}

.MessageReactionOption[data-highlighted] {
	background-color: rgba(128, 128, 128, 0.18);
	transform: translateY(-2px) scale(1.12);
}

.MessageReactionOption[data-selected="true"] {
	background-color: rgba(119, 99, 238, 0.2);
	box-shadow: inset 0 0 0 1.5px rgba(119, 99, 238, 0.65);
}

.MessageReactionOption[data-disabled] {
	opacity: 0.4;
	pointer-events: none;
}

@media (max-width: 480px) {
	.DropdownMenuContent.MessageReactionPicker {
		grid-template-columns: repeat(5, 44px);
		border-radius: 24px;
	}
	.MessageReactionOption {
		width: 44px;
		height: 44px;
	}
}

@media (prefers-reduced-motion: reduce) {
	.MessageReactionOption {
		transition: none;
	}
	.MessageReactionOption[data-highlighted] {
		transform: none;
	}
}
